<template>
  <div v-if="missingData" class="page-break">
    <source-count-table
      title="Insufficient data to generate the requested estimate"
      :note="note"
      :columnHeadings="columnHeadings"
      :rows="rows"
      footer="Below is the portion of the analysis that could be completed:"
    ></source-count-table>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off', space-in-parens: 'off' */
import sourceCountTable from "@/components/sourceCountTable";
import noDataHelper from "@/scripts/noDataHelper";

export default {
  props: ["missingData"],
  components: {
    "source-count-table": sourceCountTable,
  },
  created: function () {
    let vm = this;
  },
  data: function () {
    return noDataHelper.getDataModel(this.missingData);
  },
  methods: {},
};
</script>

<style scoped>
</style>
